import { Button } from "@/components/common/Button/Button"
import { AutoFillIcon } from "@/components/common/icons/AutoFillIcon/AutoFillIcon"
import { toast } from "@/components/common/Toast"
import { ActionSidebarRight } from "@/components/feature/ActionSidebarRight/ActionSidebarRight"
import { AnswerGenerationLoader } from "@/components/feature/AnswerGenerationLoader/AnswerGenerationLoader"
import { MainLayout } from "@/components/layout/MainLayout/MainLayout"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { ErrorPage } from "@/pages/ErrorPage"
import { isQuestionnaireNotFound } from "@/services/api/questionnaireQueryPolicy"
import { useGetQuestionnaireData } from "@/services/api/questionnaireService"
import { useParams } from "react-router"

export const GeneratingAnswersPage: React.FC = () => {
  const { translate } = useTranslation()
  const { questionnaireId, taskGroupId } =
    useParams<Record<string, string | undefined>>()

  const { data: questionnaire, error: questionnaireError } =
    useGetQuestionnaireData(questionnaireId)

  if (!questionnaireId || !taskGroupId) {
    toast.error(
      translate("QUESTIONNAIRE_ANSWERS/TOAST_ID_OR_TASKGROUP_NOT_FOUND"),
    )
    return null
  }

  if (isQuestionnaireNotFound(questionnaireError))
    return <ErrorPage variant="not-found" withLayout />

  return (
    <MainLayout
      contentCenter={
        <AnswerGenerationLoader
          autofillTaskGroupId={taskGroupId}
          questionnaireId={questionnaireId}
        />
      }
      contentRight={
        questionnaire && (
          <ActionSidebarRight
            questionnaire={questionnaire}
            handleOpenDeleteModal={() => {}}
            fileInfoActionDisabled={true}
            actionButtons={
              <>
                <Button
                  variantColor="yellow"
                  title={translate("QUESTIONNAIRE_QUESTIONS/GENERATE_ANSWERS")}
                  label={translate("QUESTIONNAIRE_QUESTIONS/GENERATE_ANSWERS")}
                  variantSize="medium"
                  isFullWidth={true}
                  IconRight={AutoFillIcon}
                  isDisabled={true}
                />

                <Button
                  variantColor="dark"
                  title={translate("QUESTIONNAIRE/CONTINUE_LATER")}
                  label={translate("QUESTIONNAIRE/CONTINUE_LATER")}
                  variantSize="medium"
                  isFullWidth={true}
                  isDisabled={true}
                />
              </>
            }
          />
        )
      }
    />
  )
}
